<template>
  <v-list-item dense three-line link @click="selActiveSpeech">
    <v-list-item-icon>
      <v-icon>mdi-message-text-outline</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>
        {{ speech.name }}
      </v-list-item-title>
      <v-list-item-subtitle class="mt-n2">
        {{ speech.description }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'SpeechesListItem',
  props: {
    speech: {
      type: Object,
      required: true
    }
  },
  methods: {
    selActiveSpeech () {
      this.$store.commit({
        type: 'selectedActiveSpeech',
        activeSpeech: this.speech
      })
    }
  }
}
</script>

<style scoped>

</style>
